import {getNotificationsHistory} from '../services/notifications.http'
import {useInfiniteQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {useMe} from '@/features/authentication/queries/useMe'
import {UserRoleE} from '@/types'

export type GetNotificationsHistoryPropsType = {
    limit?: number
    responseType?: 'small' | 'extended'
}

export const useGetNotificationsHistory = (params: GetNotificationsHistoryPropsType) => {
    const {data: user, loggedIn} = useMe()
    const isAllowed = !!user && [UserRoleE.Host, UserRoleE.Guest].includes(user?.type)

    return useInfiniteQuery({
        queryKey: [QUERY_KEYS.notificationsHistory],
        queryFn: ({pageParam}: {pageParam: number | undefined}) =>
            getNotificationsHistory({...params, fromNotificatonId: pageParam ? +pageParam : undefined}),
        enabled: isAllowed && !!loggedIn,
        initialPageParam: undefined,
        getNextPageParam: lastPage => {
            if (!lastPage || lastPage.length === 0) {
                return undefined
            }

            if (lastPage.length < (params?.limit ?? 25)) {
                return undefined
            }

            const oldestNotificationId = lastPage.at(-1)?.id
            if (oldestNotificationId) {
                return Number(oldestNotificationId)
            }

            return undefined
        }
    })
}
